import React from "react";
import EmptyCashflows from "components/CashflowsPage/EmptyCashflows";
import CashflowHeaderRow from "components/CashflowsPage/CashflowHeaderRow";
import { StyledTable, StyledTableHeaderCell, StyledCashFlowTableRow, StyledTableCell } from "components/CashflowsPage/CashFlowsTable";
import { TableBody } from "@material-ui/core";
import { format } from "date-fns";
import moment from "moment";
import numeral from "numeral";
import _ from "lodash";

const getRow = (cashflow, selection, period, isCurrentPeriod) => {
  const {
    beginDate,
    endDate,
    beginPrincipalBalance,
    interest,
    principal,
    pvFactor,
    dv01,
    pv01,
    interestRate,
    effectiveRate,
    newInterestRate,
    interestCostSavings
  } = cashflow;

  switch (selection) {
    case 0:
      return (
        <StyledCashFlowTableRow isCurrent={isCurrentPeriod}>
          <StyledTableCell>{period}</StyledTableCell>
          <StyledTableCell>{format(Date.parse(beginDate), ("MM/dd/yyyy"))}</StyledTableCell>
          <StyledTableCell>{format(Date.parse(endDate), ("MM/dd/yyyy"))}</StyledTableCell>
          <StyledTableCell>{numeral(beginPrincipalBalance).format("$0,0.00")}</StyledTableCell>
          <StyledTableCell>{numeral(interest).format("$0,0.00")}</StyledTableCell>
          <StyledTableCell>{numeral(principal).format("$0,0.00")}</StyledTableCell>
          <StyledTableCell>{numeral(principal + interest).format("$0,0.00")}</StyledTableCell>
          <StyledTableCell>{numeral(beginPrincipalBalance - (principal + interest)).format("$0,0.00")}</StyledTableCell>
        </StyledCashFlowTableRow>);
    case 1:
      return (
        <StyledCashFlowTableRow isCurrent={isCurrentPeriod}>
          <StyledTableCell>{period}</StyledTableCell>
          <StyledTableCell>{format(Date.parse(beginDate), ("MM/dd/yyyy"))}</StyledTableCell>
          <StyledTableCell>{format(Date.parse(endDate), ("MM/dd/yyyy"))}</StyledTableCell>
          <StyledTableCell>{numeral(beginPrincipalBalance).format("$0,0.00")}</StyledTableCell>
          <StyledTableCell>{numeral(interestRate).format("0.00%")}</StyledTableCell>
          <StyledTableCell>{numeral(interest).format("$0,0.00")}</StyledTableCell>
          <StyledTableCell>{numeral(principal).format("$0,0.00")}</StyledTableCell>
          <StyledTableCell>{numeral(principal + interest).format("$0,0.00")}</StyledTableCell>
          <StyledTableCell>{numeral(beginPrincipalBalance - (principal + interest)).format("$0,0.00")}</StyledTableCell>
          <StyledTableCell>{pvFactor}</StyledTableCell>
          <StyledTableCell>{dv01}</StyledTableCell>
          <StyledTableCell>{pv01}</StyledTableCell>
        </StyledCashFlowTableRow>);
    case 2:
      return (
        <StyledCashFlowTableRow isCurrent={isCurrentPeriod}>
          <StyledTableCell>{period}</StyledTableCell>
          <StyledTableCell>{format(Date.parse(beginDate), ("MM/dd/yyyy"))}</StyledTableCell>
          <StyledTableCell>{format(Date.parse(endDate), ("MM/dd/yyyy"))}</StyledTableCell>
          <StyledTableCell>{numeral(beginPrincipalBalance).format("$0,0.00")}</StyledTableCell>
          <StyledTableCell>{numeral(effectiveRate).format("0.00%")}</StyledTableCell>
          <StyledTableCell>{numeral(newInterestRate).format("0.00%")}</StyledTableCell>
          <StyledTableCell>{numeral(interestCostSavings).format("$0,0.00")}</StyledTableCell>
        </StyledCashFlowTableRow>);
  }
};

const THCashflowRow = props => {
  const {
    cashflow,
    selection,
    period
  } = props;

  // Would like to figure out how to do this isWithinInterval in date-fns.
  const isCurrentPeriod = moment.utc().isBetween(moment.utc(cashflow.beginDate), moment.utc(cashflow.endDate));

  return (getRow(cashflow, selection, period, isCurrentPeriod));
};

const getColumns = selection => {
  switch (selection) {
    case 0:
      return (
        <CashflowHeaderRow>
          <StyledTableHeaderCell>Period</StyledTableHeaderCell>
          <StyledTableHeaderCell>Start Date</StyledTableHeaderCell>
          <StyledTableHeaderCell>End Date</StyledTableHeaderCell>
          <StyledTableHeaderCell>Beginning Balance</StyledTableHeaderCell>
          <StyledTableHeaderCell>Interest</StyledTableHeaderCell>
          <StyledTableHeaderCell>Principal</StyledTableHeaderCell>
          <StyledTableHeaderCell>P&amp;I Payment</StyledTableHeaderCell>
          <StyledTableHeaderCell>Ending Balance</StyledTableHeaderCell>
        </CashflowHeaderRow>
      );
    case 1:
      return (
        <CashflowHeaderRow>
          <StyledTableHeaderCell>Period</StyledTableHeaderCell>
          <StyledTableHeaderCell>Start Date</StyledTableHeaderCell>
          <StyledTableHeaderCell>End Date</StyledTableHeaderCell>
          <StyledTableHeaderCell>Beginning Balance</StyledTableHeaderCell>
          <StyledTableHeaderCell>Rate</StyledTableHeaderCell>
          <StyledTableHeaderCell>Interest</StyledTableHeaderCell>
          <StyledTableHeaderCell>Principal</StyledTableHeaderCell>
          <StyledTableHeaderCell>P&amp;I Payment</StyledTableHeaderCell>
          <StyledTableHeaderCell>Ending Balance</StyledTableHeaderCell>
          <StyledTableHeaderCell>Pv Factor</StyledTableHeaderCell>
          <StyledTableHeaderCell>DV01</StyledTableHeaderCell>
          <StyledTableHeaderCell>PV01</StyledTableHeaderCell>
        </CashflowHeaderRow>
      );
    case 2:
      return (
        <CashflowHeaderRow>
          <StyledTableHeaderCell>Period</StyledTableHeaderCell>
          <StyledTableHeaderCell>Start Date</StyledTableHeaderCell>
          <StyledTableHeaderCell>End Date</StyledTableHeaderCell>
          <StyledTableHeaderCell>Refinanced Principal</StyledTableHeaderCell>
          <StyledTableHeaderCell>Old Interest</StyledTableHeaderCell>
          <StyledTableHeaderCell>New Interest</StyledTableHeaderCell>
          <StyledTableHeaderCell>Interest Cost / (Savings)</StyledTableHeaderCell>
        </CashflowHeaderRow>
      );
  }
};

const THCashflowTable = props => {
  const {
    selection,
    rows
  } = props;

  return (
    <>
      {
        _.isEmpty(rows) ?
          <EmptyCashflows /> :
          <StyledTable>
            {getColumns(selection)}
            <TableBody>
              {rows.map((cf, index) => (<THCashflowRow key={index} selection={selection} period={index + 1} cashflow={cf} />))}
            </TableBody>
          </StyledTable>
      }
    </>);
};

export default THCashflowTable;
